"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
// @ts-ignore
var createGenerateClassName_1 = tslib_1.__importDefault(require("@material-ui/styles/createGenerateClassName"));
// @ts-ignore
var StylesProvider_1 = tslib_1.__importDefault(require("@material-ui/styles/StylesProvider"));
var _1 = tslib_1.__importDefault(require("."));
var generateClassName = (0, createGenerateClassName_1.default)({ disableGlobal: true });
var MuiV4Compat = React.memo(function (_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(_1.default, tslib_1.__assign({}, props, { children: (0, jsx_runtime_1.jsx)(StylesProvider_1.default, tslib_1.__assign({ generateClassName: generateClassName }, { children: children })) })));
});
exports.default = MuiV4Compat;
